import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";
import { useAuth } from "../../lib/auth";

const ini = (n) => n.split(" ").filter((w) => /^[A-ZÁÉÍÓÚÑ]/.test(w)).slice(0, 2).map((w) => w[0]).join("");

export const QuickLogin = () => {
  const { quickLogin } = useAuth();
  const nav = useNavigate();
  const [users, setUsers] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => { http.get("/auth/quick-login").then((r) => setUsers(r.data.enabled ? r.data.users : [])).catch(() => setUsers([])); }, []);
  if (!users.length) return null;
  const go = async (u) => {
    setBusy(u.id);
    try { const me = await quickLogin(u.id); nav(me.role === "referenciador" ? "/portal" : "/"); } catch (e) { toast.error(errMsg(e)); setBusy(null); }
  };
  return (
    <div className="mt-8 w-full max-w-md" data-testid="quick-login">
      <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-widest text-[#8C867A]"><Zap size={12} className="text-[#E8643C]" />Acceso rápido (temporal)</p>
      <div className="mt-3 grid gap-2 sm:grid-cols-2">{users.map((u) => (
        <button key={u.id} onClick={() => go(u)} disabled={!!busy} data-testid={`quick-login-${u.id}`}
          className="group flex items-center gap-3 rounded-2xl border border-[#E2DDD5] bg-white px-3 py-2.5 text-left transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-[#E8643C] disabled:opacity-50">
          <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full text-xs font-bold ${u.portal ? "bg-[#E8643C] text-white" : "bg-[#111] text-white"}`}>{ini(u.name) || "?"}</span>
          <span className="min-w-0"><span className="block truncate text-sm font-semibold">{u.portal ? "Referenciador de prueba" : u.name}</span>
            <span className="block truncate text-xs text-[#8C867A]">{u.portal ? "Entra al portal" : u.puesto}</span></span>
        </button>))}</div>
    </div>
  );
};
